import Settings from '@core/helpers/settings.js';
import ReduxStore from '@core/libs/store/reduxStore.js';
import ApplicationBody from '@montana/components/application-body/application-body.yzal.jsx';
import i18next from 'i18next';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import ApplicationFooter from './application-footer/application-footer.yzal.jsx';
import ApplicationHeader from './application-header/application-header.yzal.jsx';

export const initReactComponents = () => {
  const appRoot = ReactDOM.createRoot(Settings.appContainerEl);
  appRoot.render(
    <Provider store={ReduxStore.store} i18n={i18next}>
      <ApplicationHeader />
      <ApplicationBody />
      <ApplicationFooter />
    </Provider>
  );
};
